<template>
  <div id="app">
    <header class="sticky">
      <div class="container">
        <div class="row">
          <div class="col main-nav">
            <span class="lead">Wydawnictwo WAM</span>
            <div v-if="loading" class="text-right loading">
              <div class="spinner-border spinner-border-sm text-light"></div>
            </div>
            <Burger />
          </div>
        </div>
      </div>
    </header>
    <Sidebar>
      <ul class="sidebar-panel-nav">
        <li>
          <router-link to="/" class="btn btn-link" >
            <span v-on:click="toggle">Home</span>
          </router-link>
        </li>
        <li>
          <router-link to="/sku" class="btn btn-link">
            <span v-on:click="toggle">SKU</span>
          </router-link>
        </li>
        <li>
          <router-link to="/ean" class="btn btn-link">
            <span v-on:click="toggle">EAN</span>
          </router-link>
        </li>
        <li>
          <router-link to="/camera" class="btn btn-link">
            <span v-on:click="toggle">CAM</span>
          </router-link>
        </li>
        <li>
          <router-link to="/shelf" class="btn btn-link">
            <span v-on:click="toggle">SHELF</span>
          </router-link>
        </li>
      </ul>
    </Sidebar>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  import Burger from '@/components/Menu/Burger'
  import Sidebar from '@/components/Menu/Sidebar'
  import { mutations } from '@/store/store.js'

  export default {
    name: 'app',
    components: {
      Burger,
      Sidebar
    },
    computed: {
      ...mapState(['loading'])
    },
    methods: {
      toggle () {
        mutations.toggleNav()
      },
      convMagazyn () {
        console.log('xxx')
      }
    }
  }
</script>

<style>
  main {
    margin: 1em .5em;
  }
  header {
    margin: 0;
    padding: .5em 1em;
    background-color: #31845d;
    color: #ffffff;
    z-index: 990;
  }
  header span {
    font-size: 1.333em;
  }
  html {
    height: 100%;
    overflow-x: hidden;
  }
  body {
    border: 0;
    margin: 0 auto;
    padding: 0;
    height: 100%;
    max-width: 720px;
    overflow-x: hidden;
    position: relative;
  }
  .logo {
    align-self: center;
    color: #fff;
    font-weight: bold;
    font-family: "Lato";
  }

  .main-nav {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0.8rem;
  }

  ul.sidebar-panel-nav {
    list-style-type: none;
  }

  ul.sidebar-panel-nav > li > a {
    color: #fff;
    text-decoration: none;
    font-size: 1.5rem;
    display: block;
    padding-bottom: 0.5em;
  }

  .sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }
  .loading {
    opacity: 0.5;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue